<form [formGroup]="formGroup" (ngSubmit)="onDownloadClicked()">
  <div class="modal-container">
    <div class="modal">
      <h2 class="modal-heading">
        RL Form Criteria
      </h2>
      <div class="modal-content">
        <div>
          <div>
            <div>
              <mat-form-field>
                <mat-label> Select Year </mat-label>
                <mat-select class="form-control" formControlName="year">
                  <mat-option value="1">Year 1</mat-option>
                  <mat-option value="2">Year 2</mat-option>
                  <mat-option value="3">Year 3</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                @if (availableCertAreas.length > 0) {
                  <mat-label> Select Cert Area </mat-label>
                }
                @if (availableCertAreas.length == 0) {
                  <mat-label> No Cert Areas </mat-label>
                }
                <mat-select class="form-control" formControlName="certArea">
                  @for (area of this.availableCertAreas; track area) {
                    <mat-option [value]="area.certAreaId">
                      {{area.name}}
                    </mat-option>
                  }
                </mat-select>
                @if (formGroup.get('certArea').invalid || formGroup.get('certArea').touched) {
                  <mat-error>
                    Cert Area is required
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn-save" [ngClass]="{'disabled-button': isDownloadDisabled() || isDownloading}" (click)="!isDownloadDisabled() && onDownloadClicked()">
          Download
        </button>
        <button type="button" class="btn-cancel" matDialogClose>
          Close
        </button>
      </div>
      @if (isDownloadDisabled()) {
        <p>Intern has no SMK Cert Areas</p>
      }
    </div>
  </div>
  @if (isDownloading) {
    <mat-progress-bar class="progress-bar" mode="query"></mat-progress-bar>
  }
</form>